<template>

  <div v-if="show" class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div class="relative bg-white rounded-lg w-full max-w-sm p-6 overflow-hidden">

      <!-- Loading Overlay -->
      <div v-if="loading" class="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-10">
        <div class="flex flex-col items-center gap-2">
          <div class="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
          <span class="text-sm text-gray-700">Processing...</span>
        </div>
      </div>

      <!-- Modal Content -->
      <h3 class="text-lg font-semibold mb-3">{{ title }}</h3>
      <p class="text-sm text-gray-600 mb-5" v-html="message"></p>

      <div class="flex justify-end gap-2">
        <button @click="$emit('cancel')" :disabled="loading" class="px-4 py-2 border rounded disabled:opacity-50">
          {{ cancelText }}
        </button>
        <button @click="$emit('confirm')" :disabled="loading"
          class="px-4 py-2 bg-orange-500 text-white rounded disabled:opacity-50">
          {{ confirmText }}
        </button>
      </div>

    </div>
  </div>

</template>

<script>
import { onMounted, onBeforeUnmount } from "vue";

export default {
  name: "ConfirmModal",
  props: {
    show: { type: Boolean, required: true },
    title: { type: String, default: "Confirm Action" },
    message: { type: String, default: "Are you sure?" },
    confirmText: { type: String, default: "Yes" },
    cancelText: { type: String, default: "Cancel" },
    loading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    // ESC key handler
    const handleEsc = (e) => {
      if ((e.key === "Escape" || e.key === "Esc") && props.show && !props.loading) {
        emit("cancel");
      }
    };

    onMounted(() => window.addEventListener("keydown", handleEsc));
    onBeforeUnmount(() => window.removeEventListener("keydown", handleEsc));
  },
};
</script>